// extracted by mini-css-extract-plugin
export default {"fallbackWrp":"groups_fallbackWrp__kgWn0","title":"groups_title__WC6IC","tip":"groups_tip__j1+fN","tab":"groups_tab__Vx9zR","checkSvg":"groups_checkSvg__7H8nw"};